import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import cat01Icon from '../../assets/icons/cat01.png';
import cat02Icon from '../../assets/icons/cat02.png';
import fireWaterIcon from '../../assets/icons/fire_water.png';

const PLAYGROUND_SCROLL_KEY = 'playground-scroll-top';
const CAT_RUNNING_IMAGE_INTERVAL = 300;

const stackingItems = [
  // {
  //   id: 'cat-running',
  //   images: [cat01Icon, cat02Icon],
  //   imageAlt: '캣러닝 아이콘',
  //   title: '캣러닝',
  //   description: '우사인냥이가 되어보자 !',
  //   point: '300',
  //   path: '/cat-running',
  //   imageClassName: 'left-[3px] top-[3px] h-[42px] w-[42px]',
  // },
  {
    id: 'fire-water',
    image: fireWaterIcon,
    imageAlt: '물냥불냥 아이콘',
    title: '물냥불냥',
    description: '다른 걸 찾으면 끝 !',
    point: '1,000',
    path: '/mulnyang-bulnyang',
    imageClassName: 'left-1 top-1 h-10 w-10',
  },
];

function RotatingCardImage({ images, image, imageAlt, imageClassName }) {
  const imageList = images?.length ? images : [image];
  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    if (imageList.length < 2) return undefined;

    const intervalId = window.setInterval(() => {
      setImageIndex((prevIndex) => (prevIndex + 1) % imageList.length);
    }, CAT_RUNNING_IMAGE_INTERVAL);

    return () => window.clearInterval(intervalId);
  }, [image, images, imageList.length]);

  return (
    <img
      src={imageList[imageIndex]}
      alt={imageAlt}
      className={`absolute object-contain ${imageClassName ?? 'left-1 top-1 h-10 w-10'}`}
    />
  );
}

function PlaygroundStackingCardItem({ image, images, imageAlt, title, description, point, onClick, imageClassName }) {
  return (
    <div
      className={`inline-flex w-full items-center justify-between rounded-[10px] bg-white py-4 pl-2.5 pr-5 shadow-[0px_6px_16px_0px_rgba(0,0,0,0.10)] ${
        onClick ? 'cursor-pointer' : ''
      }`}
      onClick={onClick}
    >
      <div className="flex items-center justify-start gap-2.5">
        <div className="relative h-12 w-12">
          <div className="h-12 w-12 rounded-[10px] bg-[#FFF0E8]" />
          <RotatingCardImage images={images} image={image} imageAlt={imageAlt} imageClassName={imageClassName} />
        </div>

        <div className="inline-flex w-40 flex-col items-start justify-start gap-1">
          <div className="self-stretch justify-center text-sm font-bold tracking-[-0.3px] text-gray05 font-['Pretendard']">
            {title}
          </div>
          <div className="self-stretch justify-center text-[11px] font-medium leading-normal text-gray03 font-['Pretendard']">
            {description}
          </div>
        </div>
      </div>

      <div className="inline-flex w-[70px] flex-col items-end justify-start gap-[3px]">
        <div className="inline-flex w-[75px] items-center justify-end">
          <div className="justify-center">
            <span className="text-base font-extrabold tracking-[-0.3px] text-gray05 font-['Pretendard']">{point} </span>
            <span className="text-sm font-bold tracking-[-0.3px] text-gray05 font-['Pretendard']">P</span>
          </div>
        </div>

        <div className="inline-flex items-center justify-center rounded-[5px] bg-background01 px-2 py-1">
          <div className="justify-center text-[10px] font-bold text-primary-blue font-['Pretendard']">최대보상</div>
        </div>
      </div>
    </div>
  );
}

function PlaygroundStackingCardList() {
  const navigate = useNavigate();

  const saveAndNavigate = (path) => {
    const pageContainer = document.getElementsByClassName('page-container')[0];
    if (pageContainer) {
      const top = Math.max(pageContainer.scrollTop ?? 0, window.scrollY || 0);
      sessionStorage.setItem(PLAYGROUND_SCROLL_KEY, String(top));
    }
    navigate(path);
  };

  return (
    <div className="flex flex-col gap-2.5 px-2">
      {stackingItems.map((item) => (
        <PlaygroundStackingCardItem
          key={item.id}
          image={item.image}
          images={item.images}
          imageAlt={item.imageAlt}
          title={item.title}
          description={item.description}
          point={item.point}
          onClick={item.path ? () => saveAndNavigate(item.path) : undefined}
          imageClassName={item.imageClassName}
        />
      ))}
    </div>
  );
}

export default PlaygroundStackingCardList;
